import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Form, FormGroup, Label, Input } from "reactstrap";
import PropTypes from "prop-types";
import Submit from "../../../components/Submit";
import { Creators as UserCreators } from "../../../store/ducks/user";
import { Creators as SubscriptionCreators } from "../../../store/ducks/subscription";

class AdminUser extends Component {
  static propTypes = {
    getSubscriptionMobileRequest: PropTypes.func.isRequired,
    update: PropTypes.func.isRequired,
    user: PropTypes.shape.isRequired
  };

  submitHandle = (e, update) => {
    e.preventDefault();
    if (e.target.email) {
      var email = e.target.email.value.trim();
    } else {
      var email = "";
    }
    update(e.target.id.value, e.target.nickname.value.trim(), email);
  };

  render() {
    return (
      <Fragment>
        <h1 className="title-underline">Meus Dados</h1>
        <div className="row">
          <div className="col-md-8">
            <Form onSubmit={e => this.submitHandle(e, this.props.update)}>
              <Input
                type="hidden"
                name="id"
                id="userId"
                defaultValue={this.props.user.id}
              />
              <FormGroup>
                <Label for="exampleEmail">Como quer ser chamado?</Label>
                <Input
                  type="text"
                  name="nickname"
                  id="UserNickname"
                  defaultValue={this.props.user.nickname}
                  required
                />
              </FormGroup>
              {!this.props.subscription.subscriptionMobile.data.id && (
                <FormGroup>
                  <Label for="exampleEmail">Email</Label>
                  <Input
                    type="email"
                    name="email"
                    id="userEmail"
                    defaultValue={this.props.user.email}
                    required
                  />
                </FormGroup>
              )}
              <Submit loading={this.props.user.updateLoading} name="Alterar" />
            </Form>
          </div>
        </div>

        {/* {this.props.payments.loading && <Loading />} */}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  subscription: state.subscription
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...UserCreators, ...SubscriptionCreators }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AdminUser);



// WEBPACK FOOTER //
// ./src/pages/admin/user/index.js